'use client'
import React, { type PropsWithChildren } from 'react'

import { StepIndicator } from '@hanzo/ui/primitives'
import { Box, cn } from '@hanzo/ui'
import AuthWidget from '../../auth/widget'

import { BackButton, Logo } from '../..'
import BagButton from '../bag-button'
import PolicyLinks from './policy-links'
import CartAccordian from './cart-accordian'
import type CheckoutPanelProps from './checkout-panel-props'


const MobileCheckoutPanel: React.FC<PropsWithChildren & CheckoutPanelProps> = ({
  step,
  stepNames,
  onLeave,
  clx='',
  children
}) => (

  <Box /* id='MOBILE_GRID' */ className={cn('bg-background flex flex-col justify-start px-4 pt-[101px]', clx)}>
    <Box className='fixed z-11 top-0 h-[45px] w-full flex justify-between items-stretch bg-background'>
      <Box className='flex items-stretch gap-1 grow-0'>
        <BackButton 
          size='sm' 
          clx={
            '-ml-5 !px-0 aspect-square h-full ' + 
            'rounded-full active:!bg-level-3 ' 
          }
          onBack={onLeave}
        />
        <Logo size='sm' variant='wordmark' href='/' onClick={onLeave} outerClx='-ml-2'/>
      </Box>
      <StepIndicator 
        dotSizeRem={1} 
        steps={stepNames} 
        currentStep={step} 
        className='relative grow mx-2 top-[14px] text-xs font-semibold w-full' 
      />

      {/* 72px by observation (for centering).  Need wrapper div since 'noLogin' returns null if no logged in user */}
      <Box className='w-[72px] grow-0 shrink-0 flex items-center justify-center'><AuthWidget noLogin className=''/></Box>
    </Box>
    <CartAccordian 
      icon={
        <BagButton 
          animateOnHover={false} 
          showIfEmpty 
          size='sm'
          className='mr-1 relative w-5 h-6 sm:w-6 sm:h-7'
          iconClx='fill-foreground'
        />
      } 
      clx='flex items-center justify-center w-full'
      triggerClx='bg-background fixed z-11 top-[45px] left-0 right-0 !m-0 px-4'
      panelClx='!py-0'
      scrollAfter={3}
      scrollHeightClx='h-[385px]' 
    />
    {children}
    <PolicyLinks clx='mt-auto mb-3 pt-2' />
  </Box>
)

export default MobileCheckoutPanel